import Vue from 'vue';

export default Vue.extend({
    data() {
        return {
            value: ''
        };
    },
    created() {
        this.value = this.params.value;
    },
    mounted() {
        Vue.nextTick(() => {
            // need to check if the input reference is still valid - if the edit was cancelled before it started there
            // wont be an editor component anymore
            if (this.$refs.input) {
                this.$refs.input.focus();
                if (this.params.keyPress === 46) {
                    this.value = null;
                } else if (this.params.charPress === null) {
                    this.value = this.params.value;
                } else if (this.value === null) {
                    this.value = this.params.charPress;
                } else {
                    this.value = this.value ?
                        Number(this.value.toString() + this.params.charPress) :
                        this.params.charPress;
                }
            }
        });
    },
    methods: {
        onChange(value) {
            this.value = value;
        },
        getValue() {
            if (this.value === '' || this.value === null) {
                return null;
            }
            if (this.isValid(this.value)) {
                return this.value;
            }
            this.$message({
                message: 'Invalid input type',
                type: 'error',
                showClose: true,
                duration: 5000
            });
            return this.params.value;
        },
        isValid(input) {
            if (/^(-)?(0|[1-9]\d*)(\s|$|\.\d{1,3}\b)/.test(input)) {
                return true;
            }
            return false;
        }
    },
    template: `
        <el-input
            v-model="value"
            @input="onChange"
            :ref="'input'"
            style="width: 100%"
        ></el-input>
    `
});



// WEBPACK FOOTER //
// ./src/views/my/planTemplate/components/numeric.js